(function () {
  if (window.__norma2) return; window.__norma2 = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function addItems(items) {
    return fetch(root + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function addToCart(id, qty) { return addItems([{ id: +id, quantity: +qty || 1 }]); }

  function prep(v) { v.muted = true; v.defaultMuted = true; v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', ''); }
  function tryPlay(v) { prep(v); var p = v.play(); if (p && p.catch) p.catch(function () {}); }

  /* Videos load only while on screen and are fully released when you scroll past them,
     so the phone never holds more than one or two videos in memory. */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) {
        if (!v.getAttribute('src') && v.dataset.src) v.src = v.dataset.src;
        tryPlay(v);
      } else {
        v.pause();
        var cs = v.getAttribute('src');
        if (cs) { if (!v.dataset.src) v.dataset.src = cs; v.removeAttribute('src'); try { v.load(); } catch (x) {} }
      }
    });
  }, { rootMargin: '200px 0px' }) : null;
  function scan(r) {
    (r || document).querySelectorAll('.n video').forEach(function (v) {
      if (v.__o) return; v.__o = 1; prep(v);
      if (io) io.observe(v); else { if (v.dataset.src) v.src = v.dataset.src; tryPlay(v); }
    });
  }
  /* Phones in low-power mode or in-app browsers block autoplay until the first touch. Runs once, not on every scroll. */
  function kick() { document.querySelectorAll('.n video').forEach(function (v) { if (!v.paused) return; var r = v.getBoundingClientRect(); if (r.bottom > 0 && r.top < innerHeight) { if (v.dataset.src && !v.getAttribute('src')) v.src = v.dataset.src; tryPlay(v); } }); }
  window.addEventListener('touchstart', kick, { passive: true, once: true });
  window.addEventListener('click', kick, { passive: true, once: true });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) kick(); });

  /* Scroll reveal: items slide up softly the first time they come into view */
  var rio = null;
  var RV = '.n .n-head, .n .n-card, .n .n-cat, .n .n-reel, .n .n-val, .n .n-pass, .n .n-blog, .n .n-faq details, .n-final, .n .n-feat, .n .n-story, .n .n-rev, .product-grid__item';
  function reveal(r) {
    if (!('IntersectionObserver' in window) || (window.Shopify && Shopify.designMode)) return;
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.documentElement.classList.add('n-rv-on');
    if (!rio) rio = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); rio.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });
    (r || document).querySelectorAll(RV).forEach(function (el) {
      if (el.__rv || el.closest('.n-pdp__grid')) return; el.__rv = 1;
      var i = Math.max(Array.prototype.indexOf.call(el.parentNode.children, el), 0);
      var d = el.classList.contains('product-grid__item') ? (i % 2) * 0.12 : Math.min(i, 5) * 0.08;
      el.style.setProperty('--d', d + 's');
      el.classList.add('n-rv');
      rio.observe(el);
    });
  }

  function tabs(r) {
    (r || document).querySelectorAll('[data-n-tabs]').forEach(function (w) {
      if (w.__t) return; w.__t = 1;
      var bs = w.querySelectorAll('[role="tab"]');
      bs.forEach(function (b) {
        b.addEventListener('click', function () {
          bs.forEach(function (x) { x.setAttribute('aria-selected', x === b ? 'true' : 'false'); });
          w.querySelectorAll('[role="tabpanel"]').forEach(function (p) { p.hidden = p.id !== b.getAttribute('aria-controls'); });
          scan(w); reveal(w);
        });
      });
    });
  }

  var sheet;
  function showSheet(item) {
    if (!sheet) {
      sheet = document.createElement('div'); sheet.className = 'n-sheet n';
      sheet.innerHTML = '<div class="n-sheet__scrim" data-x></div><div class="n-sheet__box" role="dialog" aria-modal="true" aria-label="Added to cart">' +
        '<div class="n-sheet__ok"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><path d="M5 12l5 5L20 7"/></svg>Added to cart</div>' +
        '<div class="n-sheet__item"><img alt=""><div><b></b><div class="n-price"></div></div></div>' +
        '<a class="n-btn n-btn--cta n-btn--block" href="' + root + 'checkout">Checkout · Cash on delivery</a>' +
        '<button type="button" class="n-btn n-btn--line n-btn--block" data-x>Keep shopping</button>' +
        '<a href="' + root + 'cart" style="text-align:center;font-size:13px">View cart</a></div>';
      document.body.appendChild(sheet);
      sheet.addEventListener('click', function (e) { if (e.target.closest('[data-x]')) sheet.classList.remove('is-on'); });
    }
    sheet.querySelector('img').src = item.image || '';
    sheet.querySelector('b').textContent = item.product_title || item.title || '';
    sheet.querySelector('.n-price').textContent = item.final_line_price != null ? 'LE ' + (item.final_line_price / 100).toLocaleString('en') : '';
    sheet.classList.remove('is-on'); void sheet.offsetWidth; sheet.classList.add('is-on');
    sheet.querySelector('.n-btn--cta').focus();
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  }
  /* Button turns green with a tick for a moment after adding */
  function added(btn) {
    if (!btn || btn.__lbl) return;
    btn.__lbl = btn.innerHTML; btn.classList.add('is-added'); btn.innerHTML = '✓ Added';
    setTimeout(function () { btn.innerHTML = btn.__lbl; btn.__lbl = null; btn.classList.remove('is-added'); }, 1600);
  }

  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-n-quick]');
    if (q) {
      e.preventDefault(); q.disabled = true;
      addToCart(q.dataset.nQuick, 1).then(function () { location.href = root + 'checkout'; })
        .catch(function () { q.disabled = false; location.href = q.dataset.url || root; });
    }
  });

  function pdp(r) {
    (r || document).querySelectorAll('[data-n-pdp]').forEach(function (w) {
      if (w.__p) return; w.__p = 1;
      var form = w.querySelector('form'); if (!form) return;
      var idIn = form.querySelector('[name="id"]'), qtyIn = form.querySelector('[name="quantity"]');
      var track = w.querySelector('.n-gal__track'), count = w.querySelector('.n-gal__count'), thumbs = w.querySelectorAll('.n-thumbs button');
      var n = track ? track.children.length : 0, cur = -1, raf = 0;
      /* Gallery photos load one or two ahead of the one being viewed, so the phone never holds all of them at once */
      function load(i) { var it = track && track.children[i]; if (!it) return; var img = it.querySelector('img[data-src]'); if (img) { img.src = img.dataset.src; img.removeAttribute('data-src'); } }
      function mark(i) {
        if (i === cur) return; cur = i;
        if (count) count.textContent = (i + 1) + ' / ' + n;
        thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
        load(i); load(i + 1); load(i + 2);
      }
      function goTo(k) { if (!track) return; load(k); load(k + 1); track.scrollTo({ left: track.clientWidth * k, behavior: 'smooth' }); }
      if (track) {
        track.addEventListener('scroll', function () {
          if (raf) return;
          raf = requestAnimationFrame(function () { raf = 0; mark(Math.round(Math.abs(track.scrollLeft) / (track.clientWidth || 1))); });
        }, { passive: true });
        thumbs.forEach(function (t, k) { t.addEventListener('click', function () { goTo(k); }); });
        mark(0);
      }
      w.querySelectorAll('[data-q]').forEach(function (b) { b.addEventListener('click', function () { qtyIn.value = Math.max(1, Math.min(20, (+qtyIn.value || 1) + (+b.dataset.q))); }); });
      var vars = w.querySelectorAll('.n-var'), buyBtns = w.querySelectorAll('[data-n-add],[data-n-now],[data-n-sticky],[data-n-sticky-add]');
      var priceEl = w.querySelector('[data-price]'), curPrice = priceEl ? priceEl.textContent : '', curOut = false;
      vars.forEach(function (b) { if (b.getAttribute('aria-pressed') === 'true') curOut = b.hasAttribute('data-out'); });

      /* Bundle offer: 1 piece / 2 pieces / buy 3 + 1 free, each piece can be a different color */
      var bun = w.querySelector('[data-n-bun]'), picks = bun && bun.querySelector('.n-bun__picks'), tier = 1;
      var qtyBox = w.querySelector('.n-qty');
      function setPrices(t) { document.querySelectorAll('[data-price]').forEach(function (pr) { if (w.contains(pr) || pr.closest('.n-sticky')) pr.textContent = t; }); }
      function bunTotal() { var c = bun && bun.querySelector('input:checked'); return c && c.dataset.total; }
      function colors() {
        var out = [];
        vars.forEach(function (b) { if (!b.hasAttribute('data-out')) { var im = b.querySelector('img'); out.push({ id: b.dataset.id, title: b.dataset.title, img: im ? (im.currentSrc || im.src) : '' }); } });
        if (!out.length && idIn) out.push({ id: idIn.value, title: '' });
        return out;
      }
      function buildPicks() {
        if (!picks) return;
        picks.innerHTML = '';
        if (tier < 2) { picks.hidden = true; return; }
        picks.hidden = false;
        var cs = colors();
        if (!vars.length) { picks.hidden = true; return; }
        for (var i = 0; i < tier; i++) {
          var row = document.createElement('div'); row.className = 'n-bun__row';
          var lb = document.createElement('span'); lb.className = 'n-bun__lb'; lb.textContent = 'Piece ' + (i + 1) + (tier === 4 && i === 3 ? ' · Free 🎁' : '');
          var sws = document.createElement('div'); sws.className = 'n-bun__sws'; sws.setAttribute('role', 'group'); sws.setAttribute('aria-label', 'Color for piece ' + (i + 1));
          var want = cs.some(function (c) { return c.id === idIn.value; }) ? idIn.value : cs[0].id;
          row.dataset.id = want;
          cs.forEach(function (c) {
            var bt = document.createElement('button'); bt.type = 'button'; bt.className = 'n-bun__sw'; bt.dataset.id = c.id;
            bt.setAttribute('aria-pressed', c.id === want ? 'true' : 'false');
            if (c.img) { var im = document.createElement('img'); im.src = c.img; im.alt = ''; im.loading = 'lazy'; bt.appendChild(im); }
            var nm = document.createElement('span'); nm.textContent = c.title; bt.appendChild(nm);
            sws.appendChild(bt);
          });
          row.appendChild(lb); row.appendChild(sws); picks.appendChild(row);
        }
      }
      function pickRow(row, id) {
        if (!row) return; row.dataset.id = id;
        row.querySelectorAll('.n-bun__sw').forEach(function (x) { x.setAttribute('aria-pressed', x.dataset.id === id ? 'true' : 'false'); });
      }
      if (picks) picks.addEventListener('click', function (e) {
        var bt = e.target.closest('.n-bun__sw'); if (!bt) return;
        e.preventDefault(); pickRow(bt.closest('.n-bun__row'), bt.dataset.id);
      });
      if (bun) {
        bun.querySelectorAll('input[name="n_bun"]').forEach(function (rd) {
          rd.addEventListener('change', function () {
            tier = +rd.value || 1;
            bun.querySelectorAll('.n-bun__o').forEach(function (l) { l.classList.toggle('is-on', l.contains(rd)); });
            if (qtyBox) qtyBox.hidden = tier > 1;
            buildPicks();
            setPrices(tier > 1 ? bunTotal() : curPrice);
            buyBtns.forEach(function (x) { x.disabled = tier > 1 ? false : curOut; });
          });
        });
      }

      vars.forEach(function (b) {
        b.addEventListener('click', function () {
          vars.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          idIn.value = b.dataset.id;
          var lbl = w.querySelector('[data-var-label]'); if (lbl) lbl.textContent = b.dataset.title;
          curOut = b.hasAttribute('data-out');
          if (tier < 2) buyBtns.forEach(function (x) { x.disabled = curOut; });
          if (b.dataset.vprice) { curPrice = b.dataset.vprice; if (tier < 2) setPrices(curPrice); }
          var pos = +b.dataset.pos; if (pos) goTo(pos - 1);
          if (tier > 1 && picks && !curOut) pickRow(picks.querySelector('.n-bun__row'), b.dataset.id);
        });
      });
      function msg(t) { var a = w.querySelector('[data-n-msg]'); if (!a) return; a.textContent = t; a.hidden = false; setTimeout(function () { a.hidden = true; }, 5000); }
      function cartItems() {
        if (tier > 1 && picks && picks.children.length) {
          var m = {}, order = [];
          picks.querySelectorAll('.n-bun__row').forEach(function (s) { var k = s.dataset.id; if (!m[k]) { m[k] = 0; order.push(k); } m[k]++; });
          return order.map(function (k) { return { id: +k, quantity: m[k] }; });
        }
        if (tier > 1) return [{ id: +idIn.value, quantity: tier }];
        return [{ id: +idIn.value, quantity: +(qtyIn ? qtyIn.value : 1) || 1 }];
      }
      function go(now, btn) {
        if (btn) btn.disabled = true;
        addItems(cartItems()).then(function (j) {
          if (btn) btn.disabled = false;
          if (now) location.href = root + 'checkout'; else { added(btn); showSheet(j.items ? j.items[0] : j); }
        }).catch(function (err) { if (btn) btn.disabled = false; msg((err && (err.description || err.message)) || 'Something went wrong. Please try again.'); });
      }
      w.querySelectorAll('[data-n-now]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); go(true, b); }); });
      w.querySelectorAll('[data-n-add]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); go(false, b); }); });
      form.addEventListener('submit', function (e) { e.preventDefault(); go(true, w.querySelector('[data-n-now]')); });
      var sticky = w.querySelector('.n-sticky'), box = w.querySelector('.n-buy');
      if (sticky) {
        /* Keep the buy bar pinned to the bottom of the screen on iPhone: move it out of the page
           sections (a moving parent makes a fixed bar float up while scrolling) and straight under <body> */
        document.querySelectorAll('body > .n-sticky').forEach(function (old) { if (old !== sticky) old.remove(); });
        sticky.classList.add('n');
        if (sticky.parentNode !== document.body) document.body.appendChild(sticky);
        if (box && !sticky.classList.contains('n-sticky--always')) {
          var ticking = 0;
          var upd = function () { ticking = 0; var rr = box.getBoundingClientRect(); sticky.classList.toggle('is-on', rr.bottom < 0); };
          window.addEventListener('scroll', function () { if (!ticking) { ticking = 1; requestAnimationFrame(upd); } }, { passive: true }); upd();
        }
        var sb = sticky.querySelector('[data-n-sticky]');
        if (sb) sb.addEventListener('click', function () { go(true, sb); });
        var sa = sticky.querySelector('[data-n-sticky-add]');
        if (sa) sa.addEventListener('click', function () { go(false, sa); });
      }
    });
  }

  function init(r) { scan(r); tabs(r); pdp(r); reveal(r); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();